import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.createPayment();
  }

  createPayment(event) {
    let url = this.data.get("url");
    let redirectUrl = this.data.get("redirectUrl");

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        document.querySelector(".payment-result-place-holder").innerHTML = html;

        $("#payment-result-modal").on("shown.bs.modal", function (e) {
          $(".modal-backdrop").removeClass("show");
        });

        $("#payment-result-modal").modal({
          show: true,
          backdrop: "static",
          keyboard: false
        });
        $(".spinner-container").hide();
      })
      .catch(error => {
        hideModal("#payment-result-modal");
        bootbox.alert({
          title: this.buildTitle(false),
          className: "failure-modal",
          message:
            "There is an error while processing your payment, please make sure you entered correct payment details.",
          callback: function () {
            window.parent.location = redirectUrl;
          },
          closeButton: false
        });
      });
  }

  buildTitle(success) {
    var icon_class = success
      ? `success-icon fa fa-check-circle`
      : `failed-icon fa fa-exclamation-triangle`;
    var icon_wrapper = `<i class='${icon_class}'></i>`;
    var return_message = `${icon_wrapper}${success ? "Success" : "Failed"}`;
    return return_message;
  }
}
